import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";

export default function (state = initialState.siteLinks, action) {
  switch (action.type) {
      case ActionTypes.GET_SITE_LINKS + ActionTypes.FULFILLED: //"_FULFILLED":
          return { ...action.payload.data };
    default:
      return state;
  }
}
